<template>
  <div>
    <v-container fluid>
      <v-form ref="normal_form" v-if="show_tab">
        <v-row>
          <v-col cols="12" class="pt-5 pb-1">
            <span style="color: #00a99d; font-size: 20px; font-weight: bold">
              สภาพร่างกายทั่วไป
            </span>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>น้ำหนัก (Weight)</span>
            <v-text-field
              v-model="General.weight"
              number
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุน้ำหนัก (กิโลกรัม)"
              class="custom-text-field"
              color="#00a99d"
              @keypress="validateNumber"
              type="number"
              @input="calBMI()"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>ส่วนสูง (Height)</span>
            <v-text-field
              v-model="General.height"
              outlined
              dense
              number
              hide-details="auto"
              placeholder="ระบุส่วนสูง (เซนติเมตร)"
              class="custom-text-field"
              color="#00a99d"
              @keypress="validateNumber"
              type="number"
              @input="calBMI()"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>ดัชนีมวลกาย (BMI)</span>
            <v-text-field
              v-model="General.bmi"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุดัชนีมวลกาย (กก/ม²) [ค่าปกติ : 18.5-22.9 กก/ม²"
              class="custom-text-field"
              color="#00a99d"
              readonly
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>วัดรอบเอว</span>
            <v-text-field
              v-model="General.waistline"
              outlined
              dense
              number
              hide-details="auto"
              placeholder="ระบุวัดรอบเอว"
              class="custom-text-field"
              color="#00a99d"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>โรคประจำตัว</span>
            <v-text-field
              v-model="General.congenitalDisease"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุโรคประจำตัว"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>ประวัติการแพ้</span>
            <v-text-field
              v-model="General.allergicHistory"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุประวัติการแพ้"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>ประวัติการสูบบุหรี่</span>
            <v-text-field
              v-model="General.smokingHistory"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุประวัติการสูบบุหรี่"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>ประวัติการดื่มสุรา</span>
            <v-text-field
              v-model="General.historyOfDrinking"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุประวัติการดื่มสุรา"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>ความดันโลหิตบน (BP)</span>
            <v-text-field
              v-model="General.bp_up"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุความดันโลหิต (ม.ม.ปรอท)"
              class="custom-text-field"
              color="#00a99d"
              @keypress="validateBP"
              @input="calSummaryBP()"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>ความดันโลหิตตัวล่าง (BP)</span>
            <v-text-field
              v-model="General.bp_down"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุความดันโลหิต (ม.ม.ปรอท)"
              class="custom-text-field"
              color="#00a99d"
              @keypress="validateBP"
              @input="calSummaryBP()"
            ></v-text-field>
          </v-col>
          <!-- @keypress="validateNumber"
              type="number" -->
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>ชีพจร (Pulse)</span>
            <v-text-field
              v-model="General.pulse"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุชีพจร (ครั้ง/นาที)"
              class="custom-text-field"
              color="#00a99d"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xl="3" md="3" sm="6">
            <span>ประจำเดือนมาครั้งสุดท้าย</span>
            <v-menu
              ref="menu"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
              :return-value.sync="General.lastMenstrualPeriod_show"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_format"
                  persistent-hint
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  class="mt-1"
                  hide-details=""
                  color="#00A99D"
                ></v-text-field>
              </template>
              <v-date-picker
                color="#00A99D"
                v-model="General.lastMenstrualPeriod"
                no-title
                :max="today"
              >
                <v-spacer></v-spacer>
                <v-btn color="#F5222D" outlined @click="menu2 = false">
                  ยกเลิก
                </v-btn>
                <v-btn
                  color="#00A99D"
                  style="color: white"
                  @click="
                    $refs.menu.save(saveDate(General.lastMenstrualPeriod))
                  "
                >
                  ตกลง
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12">
            <span>สรุปผลการตรวจวัดความดันโลหิตและชีพจร</span>
            <v-textarea
              v-model="General.summaryBpPuls"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <span>สภาพร่างกายทั่วไป/BMI_Comment</span>
            <v-textarea
              v-model="General.comment"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <span>สรุปผลการตรวจร่างกายทั่วไปโดยแพทย์</span>
            <v-textarea
              v-model="General.summaryPhysical"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <span>สรุปผลการตรวจภาพรังสีทรวงอก (Chest X-ray)</span>
            <v-textarea
              v-model="General.chestXray"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <span>สรุปผลการตรวจคลื่นไฟฟ้าหัวใจ (EKG)</span>
            <v-textarea
              v-model="General.ekg"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <span>สรุปผลตรวจวัดสายตาทั่วไป (Vision Test)</span>
            <v-textarea
              v-model="General.visionTest"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <span>คำแนะนำสายตา</span>
            <v-textarea
              v-model="General.visionTest_intro"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <!-- <pre>{{ General }}</pre> -->
          <v-col cols="12">
            <span style="color: #00a99d; font-size: 18px">
              ผลตรวจสายตาอาชีวอนามัย (Occupation Vision Tests)
            </span>
          </v-col>
          <v-col :cols="xs_mode ? '6' : '4'">
            <span>ประเภทการทดสอบ</span>
          </v-col>
          <v-col cols="6">
            <span>ผลตรวจ</span>
          </v-col>
          <v-col :cols="xs_mode ? '6' : '4'">
            <span class="custom-title">ทดสอบความคมชัดในการมองเห็นตาขวา</span>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="OccupationVisionTest.visionTests_R"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุความคมชัดในการมองเห็นตาขวา"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col>
          <v-col :cols="xs_mode ? '6' : '4'">
            <span class="custom-title">ทดสอบความคมชัดในการมองเห็นตาซ้าย</span>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="OccupationVisionTest.visionTests_L"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุความคมชัดในการมองเห็นตาซ้าย"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col>
          <v-col :cols="xs_mode ? '6' : '4'">
            <span class="custom-title">ทดสอบการมองชัดลึก (ภาพ 3 มิติ)</span>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="OccupationVisionTest.visionTests_3D"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุการมองชัดลึก (ภาพ 3 มิติ)"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col>
          <v-col :cols="xs_mode ? '6' : '4'">
            <span class="custom-title">ทดสอบการแยกสี</span>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="OccupationVisionTest.visionTestsSeparate"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุการแยกสี"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col>
          <!-- <v-col :cols="xs_mode ? '6' : '4'">
            <span class="custom-title">ทดสอบความสมดุลกล้ามเนื้อตา</span>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="OccupationVisionTest.visionTestsEyeMuscles"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุความสมดุลกล้ามเนื้อตา"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col> -->
          <v-col :cols="xs_mode ? '6' : '4'">
            <span class="custom-title">ทดสอบลานสายตา</span>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="OccupationVisionTest.visionTestsField"
              outlined
              dense
              hide-details="auto"
              placeholder="ระบุลานสายตา"
              class="custom-text-field"
              color="#00a99d"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <span>สรุปผลตรวจวัดสายตาอาชีวอนามัย</span>
            <v-textarea
              v-model="OccupationVisionTest.summaryVisiontest"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <span style="color: #00a99d; font-size: 18px">
              ผลตรวจสมรรถภาพการได้ยิน (Audiography)
            </span>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="audio_headers"
              :items="audio_list"
              hide-default-footer
              no-data-text="ไม่มีข้อมูล"
              style="background-color: #fcfcfc"
            >
              <template v-slot:item.test_type="{ item }">
                <span style="color: #00a99d">{{ item.test_type }}</span>
              </template>
              <template v-slot:item.type_500>
                <!-- {{ AudioGraphy }} -->
                <v-text-field
                  v-model="AudioGraphy.audiometry_R[0]"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field my-2"
                  color="#00a99d"
                  @keypress="validateNumber"
                  type="number"
                ></v-text-field>
              </template>
              <template v-slot:item.type_1000>
                <v-text-field
                  v-model="AudioGraphy.audiometry_R[1]"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field"
                  color="#00a99d"
                  @keypress="validateNumber"
                  type="number"
                ></v-text-field>
              </template>
              <template v-slot:item.type_2000>
                <v-text-field
                  v-model="AudioGraphy.audiometry_R[2]"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field"
                  color="#00a99d"
                  @keypress="validateNumber"
                  type="number"
                ></v-text-field>
              </template>
              <template v-slot:item.type_3000>
                <v-text-field
                  v-model="AudioGraphy.audiometry_R[3]"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field"
                  color="#00a99d"
                  @keypress="validateNumber"
                  type="number"
                ></v-text-field>
              </template>
              <template v-slot:item.type_4000>
                <v-text-field
                  v-model="AudioGraphy.audiometry_R[4]"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field"
                  color="#00a99d"
                  @keypress="validateNumber"
                  type="number"
                ></v-text-field>
              </template>
              <template v-slot:item.type_6000>
                <v-text-field
                  v-model="AudioGraphy.audiometry_R[5]"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field"
                  color="#00a99d"
                  @keypress="validateNumber"
                  type="number"
                ></v-text-field>
              </template>
              <template v-slot:item.type_8000>
                <v-text-field
                  v-model="AudioGraphy.audiometry_R[6]"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field"
                  color="#00a99d"
                  @keypress="validateNumber"
              type="number"
                ></v-text-field>
              </template>
              <template v-slot:body.append>
                <tr>
                  <td style="text-align: center">
                    <span style="color: #00a99d">หูซ้าย</span>
                  </td>
                  <td>
                    <v-text-field
                      v-model="AudioGraphy.audiometry_L[0]"
                      outlined
                      dense
                      hide-details="auto"
                      placeholder="ระบุผลตรวจ"
                      class="custom-text-field my-2"
                      color="#00a99d"
                      @keypress="validateNumber"
                      type="number"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="AudioGraphy.audiometry_L[1]"
                      outlined
                      dense
                      hide-details="auto"
                      placeholder="ระบุผลตรวจ"
                      class="custom-text-field my-2"
                      color="#00a99d"
                      @keypress="validateNumber"
                      type="number"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="AudioGraphy.audiometry_L[2]"
                      outlined
                      dense
                      hide-details="auto"
                      placeholder="ระบุผลตรวจ"
                      class="custom-text-field my-2"
                      color="#00a99d"
                      @keypress="validateNumber"
                      type="number"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="AudioGraphy.audiometry_L[3]"
                      outlined
                      dense
                      hide-details="auto"
                      placeholder="ระบุผลตรวจ"
                      class="custom-text-field my-2"
                      color="#00a99d"
                      @keypress="validateNumber"
                      type="number"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="AudioGraphy.audiometry_L[4]"
                      outlined
                      dense
                      hide-details="auto"
                      placeholder="ระบุผลตรวจ"
                      class="custom-text-field my-2"
                      color="#00a99d"
                      @keypress="validateNumber"
                      type="number"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="AudioGraphy.audiometry_L[5]"
                      outlined
                      dense
                      hide-details="auto"
                      placeholder="ระบุผลตรวจ"
                      class="custom-text-field my-2"
                      color="#00a99d"
                      @keypress="validateNumber"
                      type="number"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="AudioGraphy.audiometry_L[6]"
                      outlined
                      dense
                      hide-details="auto"
                      placeholder="ระบุผลตรวจ"
                      class="custom-text-field my-2"
                      color="#00a99d"
                      @keypress="validateNumber"
                      type="number"
                    ></v-text-field>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <span> ค่าปกติ : ระดับการได้ยินไม่เกิน 25 dB </span>
          </v-col>
          <v-col cols="12">
            <span>สรุปผลการตรวจสมรรถภาพการได้ยิน (Audiometry)</span>
            <v-textarea
              v-model="AudioGraphy.audiometry"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <span style="color: #00a99d; font-size: 18px">
              ผลตรวจสมรรถภาพการทํางานของปอด (Lung Function Test)
            </span>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="lung_headers"
              :items="lung_list"
              hide-default-footer
              no-data-text="ไม่มีข้อมูล"
              style="background-color: #fcfcfc"
            >
              <template v-slot:item.fvc="{}">
                <v-text-field
                  v-model="lungFunctionTest.fvc"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field my-2"
                  color="#00a99d"
                ></v-text-field>
              </template>
              <template v-slot:item.fev1="{}">
                <v-text-field
                  v-model="lungFunctionTest.fev1"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field my-2"
                  color="#00a99d"
                ></v-text-field>
              </template>
              <template v-slot:item.fev1fvc_mean="{}">
                <v-text-field
                  v-model="lungFunctionTest.fev1fvc_mean"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="ระบุผลตรวจ"
                  class="custom-text-field my-2"
                  color="#00a99d"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <span> ค่าปกติ : ใช้เกณฑ์เพศและอายุ </span>
          </v-col>
          <v-col cols="12">
            <span>สรุปผลตรวจสมรรถภาพการทำงานของปอด (Lung Function Test)</span>
            <v-textarea
              v-model="lungFunctionTest.lungFunctionTest"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <span>คำแนะนำปอด</span>
            <v-textarea
              v-model="lungFunctionTest.lungFunctionIntro"
              outlined
              dense
              hide-details="auto"
              placeholder="รายละเอียดเพิ่มเติม"
              class="custom-text-field"
              color="#00a99d"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { EventBus } from "../../EventBus";
import HealthCheckCal from "../../services/health_check_cal";

export default {
  data() {
    return {
      show_tab: false,
      date_format: "",
      menu2: false,
      today: moment().format("YYYY-MM-DD"),
      audio_headers: [
        {
          text: "ประเภทการทดสอบ",
          value: "test_type",
          align: "center",
          sortable: false,
        },
        {
          text: "500",
          value: "type_500",
          align: "center",
          sortable: false,
          width: "12%",
        },
        {
          text: "1000",
          value: "type_1000",
          sortable: false,
          align: "center",
          width: "12%",
        },
        {
          text: "2000",
          value: "type_2000",
          sortable: false,
          align: "center",
          width: "12%",
        },
        {
          text: "3000",
          value: "type_3000",
          sortable: false,
          align: "center",
          width: "12%",
        },
        {
          text: "4000",
          value: "type_4000",
          sortable: false,
          align: "center",
          width: "12%",
        },
        {
          text: "6000",
          value: "type_6000",
          sortable: false,
          align: "center",
          width: "12%",
        },
        {
          text: "8000",
          value: "type_8000",
          sortable: false,
          align: "center",
          width: "12%",
        },
      ],
      lung_headers: [
        {
          text: "FVC (%Predict)",
          value: "fvc",
          align: "center",
          sortable: false,
        },
        {
          text: "FEV1 (%Predict)",
          value: "fev1",
          align: "center",
          sortable: false,
        },
        {
          text: "FEV1/FVC (Mean)",
          value: "fev1fvc_mean",
          sortable: false,
          align: "center",
        }
      ],
      audio_list: [
        {
          test_type: "หูขวา",
          type_500: "",
          type_1000: "",
          type_2000: "",
          type_3000: "",
          type_4000: "",
          type_6000: "",
          type_8000: "",
        },
      ],
      lung_list: [
        {
          fvc: "",
          fev1: "",
          fev1fvc_mean: ""
        },
      ],
      General: {
        weight: "",
        height: "",
        bmi: "",
        comment: "",
        congenitalDisease: "",
        allergicHistory: "",
        smokingHistory: "",
        historyOfDrinking: "",
        bp: "",
        bp_up: "",
        bp_down: "",
        pulse: "",
        lastMenstrualPeriod: "",
        lastMenstrualPeriod_show: "",
        summaryBpPuls: "",
        summaryPhysical: "",
        chestXray: "",
        ekg: "",
        visionTest: "",
        waistline: "",
        visionTest_intro: ""
      },
      OccupationVisionTest: {
        visionTests_R: "",
        visionTests_L: "",
        visionTests_3D: "",
        visionTestsSeparate: "",
        visionTestsEyeMuscles: "",
        visionTestsField: "",
        summaryVisiontest: ""
      },
      AudioGraphy: {
        audiometry_R: [0, 0, 0, 0, 0, 0, 0], //หูขวา
        audiometry_L: [0, 0, 0, 0, 0, 0, 0], //หูซ้าย
        audiometry: "",
      },
      lungFunctionTest: {
        fev1_mean: "",
        fev1_predict: "",
        fev1: "",
        fvc_mean: "",
        fvc_predict: "",
        fvc: "",
        fev1fvc_mean: "",
        fev1fvc_predict: "",
        fev1_fvc: "",
        resutLungTest: "",
        lungFunctionTest: "",
        lungFunctionIntro: ""
      },
    };
  },

  created() {
    this.detailAll();
    this.show_tab = true;
  },

  computed: {
    x_mobile() {
      if (this.$vuetify.breakpoint.width < 375) {
        return true;
      } else {
        return false;
      }
    },
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },

    xs_mode() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm_mode() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    keepValue(val, type, index) {
      if (val) {
        if (type == "หูขวา") {
          this.AudioGraphy.audiometry_R[index - 1] = val;
        } else {
          //หูซ้าย
          this.AudioGraphy.audiometry_L[index - 1] = val;
        }
      }
    },
    detailAll() {
      EventBus.$on("detailAll_GetOneForm", (item) => {
        if (item !== undefined && item !== null) {
          this.General = item.general.general;
          this.date_format = item.general.general.lastMenstrualPeriod
            ? moment(item.general.general.lastMenstrualPeriod)
                .add(543, "year")
                .locale("th")
                .format("DD MMMM YYYY")
            : "";
          this.General.lastMenstrualPeriod = item.general.general.lastMenstrualPeriod;
          this.General.lastMenstrualPeriod_show = this.date_format;
          this.OccupationVisionTest = item.general.occupationVisionTest;
          this.AudioGraphy = item.general.audioGraphy;
          this.lungFunctionTest = item.general.lungFunctionTest;
        } else {
          this.clear();
        }
      });
    },
    saveDate(date) {
      this.date_format = moment(date)
        .add(543, "year")
        .locale("th")
        .format("DD MMMM YYYY");
      return moment(date).locale("th").format("YYYY-MM-DD");
    },
    clear() {
      this.General.weight = "";
      this.General.height = "";
      this.General.bmi = "";
      this.General.comment = "";
      this.General.congenitalDisease = "";
      this.General.allergicHistory = "";
      this.General.smokingHistory = "";
      this.General.historyOfDrinking = "";
      this.General.bp = "";
      this.General.bp_up = "";
      this.General.bp_down = "";
      this.General.pulse = "";
      this.General.lastMenstrualPeriod = "";
      this.General.lastMenstrualPeriod_show = "";
      this.date_format = "";
      this.General.summaryBpPuls = "";
      this.General.summaryPhysical = "";
      this.General.chestXray = "";
      this.General.ekg = "";
      this.General.visionTest = "";
      this.General.waistline = "";
      this.General.visionTest_intro = "";
      // ----------------------
      (this.OccupationVisionTest.visionTests_R = ""),
        (this.OccupationVisionTest.visionTests_L = "");
      this.OccupationVisionTest.visionTests_3D = "";
      this.OccupationVisionTest.visionTestsSeparate = "";
      this.OccupationVisionTest.visionTestsEyeMuscles = "";
      this.OccupationVisionTest.visionTestsField = "";
      this.OccupationVisionTest.summaryVisiontest = "";
      // ----------------------
      this.AudioGraphy.audiometry_R[0] = ""; //หูขวา
      this.AudioGraphy.audiometry_L[0] = ""; //หูซ้าย
      this.AudioGraphy.audiometry_R[1] = ""; //หูขวา
      this.AudioGraphy.audiometry_L[1] = ""; //หูซ้าย
      this.AudioGraphy.audiometry_R[2] = ""; //หูขวา
      this.AudioGraphy.audiometry_L[2] = ""; //หูซ้าย
      this.AudioGraphy.audiometry_R[3] = ""; //หูขวา
      this.AudioGraphy.audiometry_L[3] = ""; //หูซ้าย
      this.AudioGraphy.audiometry_R[4] = ""; //หูขวา
      this.AudioGraphy.audiometry_L[4] = ""; //หูซ้าย
      this.AudioGraphy.audiometry_R[5] = ""; //หูขวา
      this.AudioGraphy.audiometry_L[5] = ""; //หูซ้าย
      this.AudioGraphy.audiometry_R[6] = ""; //หูขวา
      this.AudioGraphy.audiometry_L[6] = ""; //หูซ้าย
      this.AudioGraphy.audiometry_R[7] = ""; //หูขวา
      this.AudioGraphy.audiometry_L[7] = ""; //หูซ้าย
      this.AudioGraphy.audiometry = "";
      // ----------------------
      this.lungFunctionTest.fvc = "";
      (this.lungFunctionTest.fvc = ""),
        (this.lungFunctionTest.fev1 = ""),
        (this.lungFunctionTest.fev1fvc_mean = "");
      this.lungFunctionTest.resutLungTest = "";
      this.lungFunctionTest.lungFunctionTest = "";
      this.lungFunctionTest.lungFunctionIntro = "";
      // ----------------------
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 46 || keyCode > 57 || keyCode == 47) {
        event.preventDefault();
      }
    },
    validateBP: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    calBMI () {
      let result = HealthCheckCal(
        "BMI",
        { weight: this.General.weight, height: this.General.height },
        { min: 18.5, max: 22.9 }
      );
      this.General.bmi =
        !isNaN(result.result) &&
        this.General.height !== "" &&
        this.General.weight !== ""
          ? result.result
          : "";
    },
    calSummaryBP () {
      let result = HealthCheckCal(
        "BP",
        { bp_up: this.General.bp_up,bp_down: this.General.bp_down, summaryBpPuls:this.General.summaryBpPuls },
        null
      );
      this.General.bp = `${this.General.bp_up}/${this.General.bp_down}`
      this.General.summaryBpPuls = result.text;
    }
  },
  watch: {
    // audio_list(val) {
    //   console.log(val, "-----");
    // },
    General: {
      handler(new_val) {
        let result = null;
        if (new_val.bmi) {
          this.General.bmi = new_val.bmi
        } else {
          if (new_val.height !== "" && new_val.width !== "") {
            // นน. สส.
            result = HealthCheckCal(
              "BMI",
              { weight: new_val.weight, height: new_val.height },
              { min: 18.5, max: 22.9 }
            );
            this.General.bmi =
              !isNaN(result.result) &&
              new_val.height !== "" &&
              new_val.width !== ""
                ? result.result
                : "";
            console.log(this.General.bmi);
            
          }
        }
        if (new_val.lastMenstrualPeriod) {
          // ประจำเดือน
          this.date_format = moment(new_val.lastMenstrualPeriod)
            .add(543, "year")
            .locale("th")
            .format("DD MMMM YYYY");
        }
        if (new_val.bp_up && new_val.bp_down ){
          result = HealthCheckCal(
            "BP",
            { bp_up: new_val.bp_up,bp_down: new_val.bp_down, summaryBpPuls:new_val.summaryBpPuls },
            null
          );
          this.General.bp = `${new_val.bp_up}/${new_val.bp_down}`
          this.General.summaryBpPuls = result.text;
        } 
        // else {
        //   const bp_split = new_val.bp.split("/")
        //   this.General.bp_up = bp_split[0]
        //   this.General.bp_down = bp_split[1]
        // }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    EventBus.$off("detailAll_GetOneForm", this.detailPhysicalExam);
  },
};
</script>

<style scoped>
.custom-text {
  display: flex !important;
  justify-content: start !important;
  align-items: end !important;
  height: 100% !important;
}
.custom-text-field {
  font-size: 14px !important;
  background-color: white !important;
}
.custom-title {
  display: flex !important;
  justify-content: start !important;
  align-items: center !important;
  height: 100% !important;
}
::v-deep .v-data-table-header th {
  color: white !important;
  font-size: 15px !important;
  background: #00a99d !important;
  font-weight: 500 !important;
}
::v-deep .v-data-table td {
  padding: 0 8px !important;
}
::v-deep .v-data-table-header th:first-child {
  border-top-left-radius: 16px;
}
::v-deep .v-data-table-header th:last-child {
  border-top-right-radius: 16px;
}

/* สำหรับ Chrome, Edge และเบราว์เซอร์ที่ใช้ WebKit */
::v-deep input[type="number"]::-webkit-inner-spin-button, 
::v-deep input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* สำหรับ Firefox */
::v-deep input[type="number"] {
    -moz-appearance: textfield;
}
</style>
